import { BrowserStorage, StorageValue } from './storage.types';

export const localStorageAdapter: BrowserStorage = {
  getItem(key: string): StorageValue {
    return localStorage.getItem(key);
  },
  setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  },
  removeItem(key: string): void {
    localStorage.removeItem(key);
  },
};
